import { useNavigate } from "@tanstack/react-router";
import { AlertCircle, ArrowLeft, Home } from "lucide-react";
import { useEffect, useState } from "react";

export function NotFound() {
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate({ to: "/" });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoToDashboard = () => {
    navigate({ to: "/" });
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <main className="max-w-2xl mx-auto py-12 px-4">
      <div className="text-center">
        {/* Icon */}
        <div className="mb-4 flex justify-center">
          <AlertCircle className="w-16 h-16 text-error/70" strokeWidth={1.5} />
        </div>

        {/* 404 Text */}
        <h1 className="text-5xl md:text-6xl font-bold text-primary mb-3">404</h1>

        {/* Main Message */}
        <h2 className="text-xl md:text-2xl font-semibold text-base-content mb-3">
          Page introuvable
        </h2>
        <p className="text-base-content/70 mb-6 max-w-md mx-auto">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        {/* Countdown */}
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 bg-base-200 px-4 py-2 rounded-full text-sm">
            <Home className="w-4 h-4 text-primary" />
            <span>
              Redirection automatique dans <strong>{countdown}s</strong>
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button onClick={handleGoToDashboard} className="btn btn-primary gap-2">
            <ArrowLeft className="w-4 h-4" />
            Tableau de bord
          </button>
          <button onClick={handleGoBack} className="btn btn-ghost gap-2">
            Page précédente
          </button>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-base-content/50 text-xs">
          <p>NeoTIM ERP • Besoin d'aide ? Contactez le support</p>
        </div>
      </div>
    </main>
  );
}
